import { render, staticRenderFns } from "./AddScore.vue?vue&type=template&id=15525f7c"
import script from "./AddScore.vue?vue&type=script&lang=js"
export * from "./AddScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports